export var API_CMDS = {
    ADDRESS: {
        ADD: 'add',
        EDIT: 'edit',
        DELETE: 'delete'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/common/messages/api.cmds.ts
// module id = ejW8
// module chunks = 18